// utils/clientCookies.ts
import { compressData, decompressData } from '../compression';
import ClientCookies from 'js-cookie';

export interface CookieProps {
  name: string;
  value?: any;
  options?: {
    httpOnly?: boolean;
    secure?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
    path?: string;
    expires?: Date;
    maxAge?: number;
  };
  isParse?: boolean;
  isCompress?: boolean;
}

export const getClientCookie = ({ name, isParse = true, isCompress = true }: CookieProps) => {
  const value = ClientCookies.get(name);
  if (value && isParse) {
    return isCompress ? decompressData({ value, isParse }) : value ? JSON.parse(value) : null;
  }
  return value;
};

export const setClientCookie = ({ name, isParse = true, isCompress = true, value, options }: CookieProps) => {
  const compressValue = isCompress ? compressData({ value, isParse }) : value;
  const finalValue = isParse && !isCompress ? JSON.stringify(value) : compressValue;
  
  ClientCookies.set(name, finalValue, {
    path: options?.path || '/',
    expires: options?.expires,
    secure: options?.secure ?? import.meta.env.PROD,
    sameSite: options?.sameSite || 'lax'
  });
};

export const deleteClientCookie = ({ name }: CookieProps) => {
  ClientCookies.remove(name, { path: '/' });
};

export const deleteAllClientCookies = () => {
  Object.keys(ClientCookies.get()).forEach(cookieName => {
    ClientCookies.remove(cookieName, { path: '/' });
  });
};